import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=8e9891a6&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9891a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8e9891a6', component.options)
    } else {
      api.reload('8e9891a6', component.options)
    }
    module.hot.accept("./CardItem.vue?vue&type=template&id=8e9891a6&scoped=true&", function () {
      api.rerender('8e9891a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lists/CardItem.vue"
export default component.exports